package ai.wagemix.net.client

import com.fsryan.foundation.net.client.FSAuthenticatedRequestBuilder
import com.fsryan.foundation.net.client.FSRequest
import com.fsryan.foundation.net.client.acceptJson
import com.fsryan.foundation.net.client.pathParamFollowing
import com.fsryan.foundation.net.client.replacePathParams

/** `GET /api/v1/billing/checkout-sessions/{id}`: what a completed checkout bought; the session must belong to the caller. */
class WMCheckoutSessionRequestBuilder: FSAuthenticatedRequestBuilder<WMCheckoutSessionRequestBuilder, Nothing>() {

    private var sessionId: String? = null

    fun sessionId(sessionId: String): WMCheckoutSessionRequestBuilder {
        this.sessionId = sessionId
        return this
    }

    override fun applyFrom(request: FSRequest<Nothing>): WMCheckoutSessionRequestBuilder {
        sessionId = request.pathParamFollowing("checkout-sessions")
        return super.applyFrom(request)
    }

    override fun build(): FSRequest<Nothing> {
        method(FSRequest.Method.Get)
        val id = sessionId ?: error("A checkout session id must be provided")
        replacePathParams("api", "v1", "billing", "checkout-sessions", id)
        acceptJson()
        return super.build()
    }

    override fun clear(): WMCheckoutSessionRequestBuilder {
        sessionId = null
        return super.clear()
    }

    override fun self(): WMCheckoutSessionRequestBuilder = this
}
